module.exports = __webpack_public_path__ + "media/images/cirp-e0fbb453c01e89e71ed5bf32a42044a9.png";